import { render, staticRenderFns } from "./smallBagShip.vue?vue&type=template&id=0f9ec4a9&scoped=true&"
import script from "./smallBagShip.vue?vue&type=script&lang=js&"
export * from "./smallBagShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ec4a9",
  null
  
)

export default component.exports